import { render } from "./QRCode.vue?vue&type=template&id=0b91dace&scoped=true"
import script from "./QRCode.vue?vue&type=script&lang=js"
export * from "./QRCode.vue?vue&type=script&lang=js"

import "./QRCode.vue?vue&type=style&index=0&id=0b91dace&scoped=true&lang=css"

import exportComponent from "C:\\Users\\noklo\\Documents\\GitHub\\Rayong\\Rayong-register-student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b91dace"]])

export default __exports__